// WhatsApp helper service - phone formatting and message templates
// No external API; uses wa.me click-to-chat.

/**
 * Normalize a raw phone number into an international format usable by wa.me.
 * Defaults to Saudi Arabia (966) if a leading 0 is given without country code.
 */
export function formatPhoneInternational(raw, defaultCountry = "966") {
  if (!raw) return "";
  let digits = String(raw).replace(/[^0-9]/g, "");
  if (!digits) return "";
  // Already international (starts with country code length 1-3 + number)
  if (digits.startsWith("00")) digits = digits.slice(2);
  // Leading 0 → replace with default country code
  if (digits.startsWith("0")) digits = defaultCountry + digits.slice(1);
  // Bare local 9-10 digit Saudi (5xxxxxxxx) → prepend country
  if (digits.length <= 10 && !digits.startsWith(defaultCountry)) {
    if (digits.startsWith("5") || digits.length === 10) {
      digits = defaultCountry + digits;
    }
  }
  return digits;
}

const GOOGLE_REVIEW_URL = "https://g.page/r/CT_zZKXXOVpYEBM/review";

/**
 * Build the trilingual WhatsApp invoice message.
 * lang: "id" | "ar" | "en"
 */
export function buildInvoiceMessage({ customerName, totalAmount, transactionDate, invoiceUrl, lang = "id" }) {
  if (lang === "ar") {
    const name = customerName || "عميلنا";
    return [
      `مرحبًا ${name}،`,
      ``,
      `شكرًا لزيارتكم *Java SPA*.`,
      ``,
      `فيما يلي فاتورة معاملتكم:`,
      ``,
      invoiceUrl,
      ``,
      `إجمالي المبلغ المدفوع: ${totalAmount}`,
      ``,
      `التاريخ: ${transactionDate}`,
      ``,
      `هل أعجبتكم خدمتنا؟ يسعدنا سماع رأيكم! يرجى ترك تقييم بالنجوم ومراجعة على Google. دعمكم يعني لنا الكثير ⭐`,
      ``,
      GOOGLE_REVIEW_URL,
      ``,
      `شكرًا لكم.`,
    ].join("\n");
  }
  if (lang === "en") {
    const name = customerName || "Customer";
    return [
      `Hello ${name},`,
      ``,
      `Thank you for visiting *Java SPA*.`,
      ``,
      `Please find your transaction invoice below:`,
      ``,
      invoiceUrl,
      ``,
      `Total Payment: ${totalAmount}`,
      ``,
      `Date: ${transactionDate}`,
      ``,
      `Like our service? We'd love to hear your feedback! Please leave us a star rating and review on Google. Your support means a lot to us ⭐`,
      ``,
      GOOGLE_REVIEW_URL,
      ``,
      `Thank you.`,
    ].join("\n");
  }
  // Indonesian (default)
  const name = customerName || "Pelanggan";
  return [
    `Halo ${name},`,
    ``,
    `Terima kasih telah berkunjung ke *Java SPA*.`,
    ``,
    `Berikut invoice transaksi Anda:`,
    ``,
    invoiceUrl,
    ``,
    `Total Pembayaran: ${totalAmount}`,
    ``,
    `Tanggal: ${transactionDate}`,
    ``,
    `Suka dengan layanan kami? Kami ingin sekali mendengar masukan Anda! Mohon beri rating bintang & ulasan di Google. Dukungan Anda sangat berarti ⭐`,
    ``,
    GOOGLE_REVIEW_URL,
    ``,
    `Terima kasih.`,
  ].join("\n");
}

/**
 * Open WhatsApp click-to-chat with pre-filled message.
 */
export function openWhatsapp(phoneIntl, message) {
  const encoded = encodeURIComponent(message);
  const url = phoneIntl
    ? `https://wa.me/${phoneIntl}?text=${encoded}`
    : `https://wa.me/?text=${encoded}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
